import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isPlatformHost } from "@/utils/isPlatformHost";

const STORAGE_KEY = "last_route";
const EXCLUDED = ["/auth", "/reset-password"];

/**
 * Persists the current route to localStorage and restores it on initial load.
 * Call once inside the authenticated app layout.
 */
export const useRouteRestore = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // On mount: if we're at "/" and there's a saved route, redirect
  useEffect(() => {
    if (!isPlatformHost(window.location.hostname)) return;

    if (location.pathname === "/") {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved && saved !== "/" && !EXCLUDED.includes(saved)) {
          navigate(saved, { replace: true });
        }
      } catch {
        /* localStorage unavailable in private browsing */
      }
    }
    // Only run once on mount
  }, [navigate, location.pathname]);

  // Persist route changes
  useEffect(() => {
    if (!isPlatformHost(window.location.hostname)) return;

    if (!EXCLUDED.includes(location.pathname)) {
      try {
        localStorage.setItem(STORAGE_KEY, location.pathname + location.hash);
      } catch {
        /* localStorage unavailable in private browsing */
      }
    }
  }, [location.pathname, location.hash]);
};
